import { FetchAssistant } from '../../utils';
import { authService } from '../authService';

/**
 * 
 */
export class RosterController {

    /**
     * @param { { projectKey: string, localeCode: string, localTranslationBundles: object, attemptFetch: boolean } } 
     */
    constructor( { debug = false } = {} ) {
        // ...

        // Create a fetch assistant with a middleware function that passes in the user's
        // access token if available. This is meant to make any potentially necessary
        // Roster requests easier.
        this._fetchAssistant = new FetchAssistant( 'roster', [ ( _endpoint, options ) => {
            options.headers = { ...( options.headers || {} ) };
            const bearerToken = authService.getAccessToken();
            if ( bearerToken ) {
                options.headers.authorization = `Bearer ${ bearerToken }`;
            }
        } ] );
    }

    /**
     * Creates a request using the given options. Note that the user's access
     * token is already being pulled from the Auth Service and is injected into
     * the request headers if available. If the Auth Service can't provide a
     * valid access token at the time of the request, your request may fail.
     * 
     * @param { object } options
     */
    async fetch( { endpoint, method = 'GET', headers, body, bearerToken = undefined } ) {
        return await this._fetchAssistant.fetch( { endpoint, method, headers, body, bearerToken } );
    }

    /**
     * ...
     * 
     * @param { string } localeCode - The locale code to use in translations.
     * @returns { boolean }
     */
    setPreferredLanguage( localeCode ) {
        if ( localeCode ) {
            // ...
            return true;
        } else {
            console.warn( `Cannot set preferred language of '${ localeCode }'.` );
            return false;
        }
    }

}
